import { api } from "./api";

export const rteTransactionStore = async (data) => {
  return await api.post(`/rte-transactions`, data);
};

export const fetchRteTransactions = async (addUrl = ``) => {
  return await api.get(`/fetch/rte-transactions?${addUrl}`);
};
